import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  TextField, 
  Button, 
  Link,
  useTheme
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const VerifyCodeScreen = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  let verifyImage;
  try {
    verifyImage = require('../assets/Logo.png');
  } catch (error) {
    verifyImage = null;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Grid container spacing={0} sx={{ 
        borderRadius: 4,
        overflow: 'hidden',
        boxShadow: 3,
        border: '1px solid #d0d0d0'
      }}>
        {/* Left Column - Form */}
        <Grid item xs={12} md={6} sx={{ 
          backgroundColor: theme.palette.primary.mainLoginBackground,
          py: 6,
          px: { xs: 3, md: 6 }
        }}>
          <Box sx={{ maxWidth: 500, mx: 'auto' }}>
            {/* Back to Login Link */}
            <Link href="#" sx={{ 
              display: 'flex',
              alignItems: 'center',
              mb: 3,
              color: theme.palette.blackandWhite.main,
              textDecoration: 'none',
              fontWeight: 500,
              '&:hover': {
                textDecoration: 'underline'
              }
            }}>
              <ArrowBack sx={{ mr: 1 }} />
              {t('Back to login')}
            </Link>
            
            <Typography variant="h4" component="h1" sx={{ 
              fontWeight: 700, 
              mb: 1,
              color: theme.palette.blackandWhite.main
            }}>
              {t('Verify code')}
            </Typography>
            
            <Typography variant="body1" sx={{ 
              mb: 4,
              color: theme.palette.text.secondary
            }}>
              {t('authCodeSent')}
            </Typography>
            
            {/* OTP Input */}
            <Box sx={{ mb: 3 }}>
              <TextField
                fullWidth
                id="otpCode"
                name="otpCode"
                label={t("Enter OTP Code")}
                sx={{ 
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: theme.palette.primary.mainTextFieldBackground,
                  }
                }}
              />
            </Box>
            
            {/* Resend Code Link */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Typography variant="body1" sx={{ display: 'inline-block' }}>
                {t("Didn't receive a code?")}  {'  '}
              </Typography>
              <Link href="#" sx={{ 
                color: theme.palette.primary.main,
                fontWeight: 600,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}>
                 {t("Resend")}
              </Link>
            </Box>
            
            {/* Verify Button */}
            <Button
              fullWidth
              variant="contained"
              sx={{
                py: 1.5,
                mb: 3,
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: '8px'
              }}
            >
              {t('Verify')}
            </Button>
          </Box>
        </Grid>
        
        {/* Right Column - Image */}
        <Grid item xs={12} md={6} sx={{ 
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5'
        }}>
          {verifyImage ? (
            <img 
              src={verifyImage} 
              alt="Verification" 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover',
                display: 'block'
              }} 
            />
          ) : (
            <Box sx={{ 
              width: '100%', 
              height: '100%', 
              minHeight: 400,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Typography variant="h6" color="textSecondary">
                Verification Image
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default VerifyCodeScreen;